import { makeStyles } from '@material-ui/core';
import React from 'react';
import { SearchableSelect } from '../../UI';
import { PropTypes } from 'prop-types';
import { ArrowBottomIcon } from '../../UI/Images/Icons';
import { isPersian } from '../../../utils/checkLang';

const styles = makeStyles({
    inputRoot: {
        border: 'solid 1px #e8ecf2',
        backgroundColor: '#ffffff',
        // borderRadius: (props) => (props.isMobile ? '4px' : '9px'),
        opacity: ({ inputOpacity }) => (inputOpacity ? inputOpacity : 1),
        fontSize: '13px',
        minWidth: ({ width }) => (width ? width : 'unset'),
        paddingRight: '0 !important',
        '&:focus-within': {
            border: 'solid 1px #1b90fa'
        }
    },
    label: {
        fontSize: '13px',
        fontFamily: 'inherit',
        fontWeight: '500',
        color: '#545e66',
        paddingBottom: '8px'
    },
    arrowWrapper: {
        width: '15px',
        height: '15px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    arrowIcon: ({ color, mb, size }) => ({
        width: '15px',
        height: '15px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& i': {
            border: color ? `solid ${color}` : `solid #509ffa`,
            borderWidth: '0 2px 2px 0',
            display: 'inline-block',
            padding: size ? size + 'px' : '4px',
            transform: 'rotate(45deg)',
            marginBottom: mb ? mb + 'px' : '7px'
        }
    }),
    endAdornment: {
        position: 'unset',
        padding: '0 5px'
    },
    option: {
        direction: 'ltr',
        fontFamily: 'mainFont',
        fontSize: '14px'
    }
});

const SelectionForm = ({
    options,
    label,
    name,
    value,
    inputValue,
    handleChange,
    noIcon = false,
    loading,
    inputOpacity,
    open,
    width
}) => {
    const classes = styles({ width, inputOpacity });
    return (
        <div className={classes.selectWrapper}>
            <SearchableSelect
                openWithCustomInput={open}
                width="100%"
                optionsDirection="rtl"
                customClasses={classes}
                optionalToUse
                options={options}
                optionsLabel="name"
                customValue={value}
                customInputValue={inputValue}
                label={label}
                name={name}
                loading={loading}
                setValue={(id, name) => {
                    handleChange({ id, name });
                }}
                hasValidation={false}
                customIcon={noIcon ? <></> : <ArrowBottomIcon color="#416ce1" />}
                renderOption={(props) => (
                    <span
                        {...props}
                        style={{
                            marginInlineStart: isPersian(props.name) && 'auto',
                            textAlign: isPersian(props.name) ? 'right' : 'left'
                        }}
                    >
                        {props.name}
                    </span>
                )}
            />
        </div>
    );
};
SelectionForm.propTypes = {
    options: PropTypes.array,
    label: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    inputValue: PropTypes.string,
    handleChange: PropTypes.func,
    noIcon: PropTypes.bool,
    open: PropTypes.bool,
    width: PropTypes.string,
    inputOpacity: PropTypes.string,
    loading: PropTypes.bool
};
export default SelectionForm;
